export default "__VITE_ASSET__1fc95df3__"